export const DOCUMENTATION_URL =
  'https://www.notion.so/ybknowledgebase/Adding-a-Looker-Studio-embed-in-Yieldbird-Platform-b6a65082dedc41c4b2c6a8e96be0d755'
